import { EXPIRING_SOON_NOTICE_IN_DAYS } from '../constants/certifications';
export const getExpiringInXDays = expirationTimestampInUtc => {
  const msDifference = expirationTimestampInUtc - Date.now();
  const daysDifference = msDifference / (1000 * 60 * 60 * 24);
  return Math.round(daysDifference);
};
export const isExpiringSoon = expirationDate => {
  const diffDays = getExpiringInXDays(expirationDate);
  return diffDays >= 0 && diffDays <= EXPIRING_SOON_NOTICE_IN_DAYS;
};